<div
  class="managed-services-header"
  [class.overflow-hidden]="showDashboardTabs && dashboards.length > 0"
  [class.button-tooltip]="canAddTicket && isOnTicketsRoute"
  [class.hide-divider]="hideTicketsHeader"
>
  <div class="managed-services-title-container" #titleContainer>
    @if (!hideTicketsHeader) {
      <h1 class="headline mr-3 mb-0" style="display: inline-block">
        MANAGED <span style="font-weight: bold">SERVICES</span> {{ subtitle }}
      </h1>
    }
    @if (canAddTicket && isOnTicketsRoute && !hideTicketsHeader) {
      <add-button class="ml-2" [tooltipText]="'ADD TICKET'" (click)="openAddTicketDialog()"></add-button>
    }
  </div>
  <div class="managed-services-tabs-container" #tabsContainer>
    @if (showDashboardTabs && dashboards.length > 0) {
      @if (!tabsAreClose) {
        <mat-tab-group
          class="hub-page-tabs ms__header-tabs ml-auto"
          mat-align-tabs="start"
          [selectedIndex]="selectedDashboardTabIndex"
          (selectedTabChange)="onDashboardTabChange($event)"
        >
          @for (tab of dashboards; track tab.value) {
            <mat-tab [label]="tab.name"></mat-tab>
          }
        </mat-tab-group>
      } @else {
        <form-element-renderer
          [reactiveForm]="dashboardsForm"
          [controlName]="'dashboard'"
          [controlConfig]="formControlsConfigMap.get('dashboard')"
        >
        </form-element-renderer>
      }
    }
  </div>
</div>
<div class="h-100 overflow-hidden ms__content">
  <router-outlet></router-outlet>
</div>
